export const inputStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '60%',
  marginBottom: '0.5em',
  marginTop: '0.5em',
  gridGap: '1em',
};

export const priceRangeErrorStyle = {
  marginBottom: '1em',
};
